module.exports = __webpack_public_path__ + "public/files/img/8.36f1e648.png";